const weekday = {
  0: {
    abbr: 'Sun',
    fullName: 'Sunday',
  },
  1: {
    abbr: 'Mon',
    fullName: 'Monday',
  },
  2: {
    abbr: 'Tue',
    fullName: 'Tuesday',
  },
  3: {
    abbr: 'Wed',
    fullName: 'Wednesday',
  },
  4: {
    abbr: 'Thu',
    fullName: 'Thursday',
  },
  5: {
    abbr: 'Fri',
    fullName: 'Friday',
  },
  6: {
    abbr: 'Sat',
    fullName: 'Saturday',
  },
};

export function getWeekdayName(i) {
  return weekday[`${i % 7}`].fullName;
}

export function getWeekdayAbbr(i) {
  return weekday[`${i % 7}`].abbr;
}



// WEBPACK FOOTER //
// ./domain/Weekday/index.jsx